import { render, staticRenderFns } from "./custom-table.vue?vue&type=template&id=0f96f680&scoped=true&"
import script from "./custom-table.vue?vue&type=script&lang=js&"
export * from "./custom-table.vue?vue&type=script&lang=js&"
import style0 from "./custom-table.vue?vue&type=style&index=0&id=0f96f680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96f680",
  null
  
)

export default component.exports